import { createContext } from 'react'

export const FirebaseContext = createContext<any | null>(null)
